<template>
    <div class="container h-100">
      <div class="d-flex justify-content-center h-100">
        <div class="user_card">
          <div class="d-flex justify-content-center">
            <div class="brand_logo_container">
              <img
                src="images/logo.jpg"
                class="brand_logo"
                alt="Logo"
              />
            </div>
          </div>
          <h5 style="color:white;" class="mt-4 d-flex justify-content-center"> Forget Password</h5>
          <p style="color:white;" >Enter your registered Email Address, We’ll send you OTP for change password.</p>
          <div class="d-flex justify-content-center">
            <form class="login-form">
              <div class="input-group mb-2">
                <div class="input-group-append">
                  <span class="input-group-text"
                    ><i class="fas fa-envelope"></i
                  ></span>
                </div>
                <input type="email" name="" class="form-control input_user" @keyup="validateEmail" v-model="email" placeholder="Email"/>
              </div>
            <div v-if="e_error" class="alertError">{{ e_error }}</div>
              <div class="d-flex justify-content-center login_container">
                <button type="button" v-on:click="forgot" @click="toast" name="button" class="btn login_btn">
                  Send OTP
                </button>
              </div>  
            </form>
          </div>
  
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { defineComponent } from 'vue'
  import { createToast } from 'mosha-vue-toastify';
  import 'mosha-vue-toastify/dist/style.css'
  import { base_url } from "../../config";
  import axios from "../../services/customAxios";
  export default defineComponent({
    name:'Login',
    setup () {
      const toast = () => {
          createToast()
      }
      return { toast }
    },
    data() {
      return {
        email: "",
        base_url: base_url,
        e_error:"",
      };
    },
    methods:{
    async forgot(){
      try{
      let response = await axios.post(`${base_url}/send_otp`, {
        email: this.email,
      });
      let result = response.data.result.id;
      console.log("result",result)
      localStorage.setItem('ForgotId', result);
      createToast({title: "Success", description: response.data.message},{type: "default"})
      this.$router.push({ name:"VerifyOTP" });
      }
      catch(error){
        createToast({title: "Error", description: error?.response?.data?.message},{type: "danger"})
      }
    },
    validateEmail() {
      if (!/\S+@\S+\.\S+/.test(this.email)) {
        this.e_error = 'Please enter a valid email address.';	
      } 
      else {
       this.e_error = '';
      }
    },
  },
  });
  </script>
  
  <style  scoped>
  .white{
    color: white;
  }
  </style>